module.exports = __webpack_public_path__ + "static/img/img-tec-03-circle.95dfecc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/img-tec-03-circle.png
// module id = RUe1
// module chunks = 1